import { ArrowRight } from '@outdoor-voices/ui';
import { memo, useContext } from 'react';
import PropTypes from 'prop-types';
import { parseMarkdown } from './utils';
import { ProductContext } from '../context';
import css from './index.module.scss';
import EverGreen from '../../../components/EverGreen';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var FabricLink = function FabricLink() {
  var _useContext = useContext(ProductContext),
      fabric = _useContext.fabric;

  if (!fabric) {
    return /*#__PURE__*/_jsx(_Fragment, {});
  }

  var id = fabric.id,
      attributes = fabric.attributes,
      composition = fabric.composition,
      evergreen = fabric.evergreen,
      parent = fabric.parent,
      title = fabric.title,
      url = fabric.url;
  var panelTitle = url ? /*#__PURE__*/_jsxs("a", {
    "aria-label": "This product is made with the ".concat(title, " fabric.\n      Click to navigate to the ").concat(title, " collection of products."),
    href: "".concat(url, "?fabric=").concat(parent ? parent.id : id),
    children: [title, " ", /*#__PURE__*/_jsx(ArrowRight, {})]
  }) : title;
  return /*#__PURE__*/_jsxs("div", {
    className: css.col,
    children: [/*#__PURE__*/_jsx("div", {
      className: css.panelTitle,
      children: panelTitle
    }), attributes && /*#__PURE__*/_jsx("div", {
      className: css.attributes,
      dangerouslySetInnerHTML: {
        __html: parseMarkdown(attributes)
      }
    }), evergreen && /*#__PURE__*/_jsx(EverGreen, {
      info: true,
      small: true
    }), /*#__PURE__*/_jsx("div", {
      dangerouslySetInnerHTML: {
        __html: parseMarkdown(composition)
      }
    })]
  });
};

FabricLink.propTypes = {
  description: PropTypes.string,
  title: PropTypes.string
};
export default /*#__PURE__*/memo(FabricLink);